import { lazy } from 'react'

import Permessi from './permessi'
import VociContratto from './voci-contratto'

export default {
    path: '/contratti',
    title: 'Commesse',
    authenticated: true,
    component: lazy(() => import('./filter')),
    pages: [
        {
            path: '/:contrattoId',
            title: 'Commessa: {{params.contrattoId}}',
            drawer: false,
            component: lazy(() => import('./detail')),
            pages: [VociContratto, Permessi]
        }
    ]
}